// Thin wrapper around the app's single shared Socket.IO client (app/socketClient)
// so the ported KAI Select real-time listeners (syncdataListener, useAhuSocketParams)
// don't open a second parallel connection to the same namespace.
import { getSocket } from '../../../app/socketClient';

export function subscribeToEvent(
  eventName: string,
  callback: (data: any) => void
): () => void {
  const socket = getSocket();
  socket.on(eventName, callback);
  return () => {
    socket.off(eventName, callback);
  };
}

export function sendMessage(eventName: string, data: any): void {
  const socket = getSocket();
  if (!socket.connected) return;
  socket.emit(eventName, data);
}
